// export const ConvertUTCtoLocal = (date, time, dateTime) => {
//   // Combine the date and time into a single string (UTC time)
//   const combinedDatetime = `${date}T${time}Z`; // The "Z" at the end indicates UTC

//   // Create a new Date object, which will be in UTC
//   const utcDate = new Date(combinedDatetime);

//   // Convert to the system's local time zone
//   const localDate = utcDate.toLocaleString(); // Full local date and time

//   // Local date only (without time)
//   const localDateOnly = utcDate.toLocaleDateString(); // Local date only

//   // Local time only (without date)
//   const localTimeOnly = utcDate.toLocaleTimeString("en-US", {
//     timeZoneName: "short", // Short time zone format (e.g., GMT-4)
//   }); // Local time only

//   // Full local date and time with time zone information
//   const localDateWithTimeZone = utcDate.toLocaleString("en-US", {
//     timeZoneName: "short", // Short time zone format (e.g., GMT-4)
//   });

//   return {
//     date: localDateOnly,
//     time: localTimeOnly,
//     dateTime: localDateWithTimeZone,
//   };
// };

export const ConvertUTCtoLocal = (date, time, dateTime) => {
  // Combine the date and time into a single string (UTC time)
  const combinedDatetime = `${date}T${time}Z`; // The "Z" at the end indicates UTC

  // Create a new Date object, which will be in UTC
  const utcDate = new Date(combinedDatetime);

  // Convert to the system's local time zone
  const localDate = utcDate.toLocaleDateString(); // Local date only

  // Local time only (without date) and without seconds
  const localTimeOnly = utcDate.toLocaleTimeString("en-US", {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // 12-hour format
  }); // Local time only, no seconds, 12-hour format

  // Full local date and time with time zone information, but without seconds and time zone
  const localDateWithTimeZone = `${localDate}, ${localTimeOnly}`;

  return {
    date: localDate,
    time: localTimeOnly,
    dateTime: localDateWithTimeZone,
  };
};



/** `get-program-subscription-list-user` program `ID` for "Japa 6 Month Transformation Membership". */
export const JAPA_SIX_MONTH_TRANSFORMATION_MEMBERSHIP_PROGRAM_ID = 15;

/** Same API list: "Transformer" subscription row to hide when the 6‑month membership above is active. */
export const TRANSFORMER_PROGRAM_SUBSCRIPTION_ID = 20;

function paymentHistoryMatchesProgramSubscription(row, planId) {
  if (!row) return false;
  const pid = String(planId);
  if (row.subscriptionId != null && String(row.subscriptionId) === pid) return true;
  if (row.programSubscriptionId != null && String(row.programSubscriptionId) === pid) return true;
  if (row.programSubscriptionID != null && String(row.programSubscriptionID) === pid) return true;
  if (row.js_programSubscription?.ID != null && String(row.js_programSubscription.ID) === pid) {
    return true;
  }
  return false;
}

function sortPaymentHistoryRowsNewestFirst(rows) {
  return rows.slice().sort((a, b) => {
    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
    if (aTime !== bTime) return bTime - aTime;
    return (Number(b?.ID) || 0) - (Number(a?.ID) || 0);
  });
}

/**
 * True while the member still has access for this payment row.
 * CANCELLED = auto-renew off (cancel_at_period_end); access continues until expirationTime.
 * Payment History UI still shows "Cancelled" separately via orderStatus.
 */
export const isPaymentHistoryRowCurrentlyActive = (row) => {
  if (!row || row.orderStatus === "FAILED") return false;
  const status = row.orderStatus;
  if (status !== "ACTIVE" && status !== "CANCELLED") return false;
  const endRaw = row.expirationTime;
  if (endRaw == null || endRaw === "") {
    return status === "ACTIVE" || status === "CANCELLED";
  }
  const start = row.createdAt ? new Date(row.createdAt) : null;
  const end = new Date(endRaw);
  const today = new Date();
  if (!start || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return !Number.isNaN(end.getTime()) && end > today;
  }
  if (today < start || today > end) return false;
  return true;
};

export const hasActivePlanInPaymentHistory = (paymentHistoryList, planId) => {
  if (!Array.isArray(paymentHistoryList) || paymentHistoryList.length === 0) return false;
  const matches = paymentHistoryList.filter((h) =>
    paymentHistoryMatchesProgramSubscription(h, planId)
  );
  const latest = sortPaymentHistoryRowsNewestFirst(matches)[0];
  return latest ? isPaymentHistoryRowCurrentlyActive(latest) : false;
};

export const hasActiveAccessFromPaymentHistory = (list) => {
  if (!Array.isArray(list) || list.length === 0) return false;
  const planIds = new Set();
  list.forEach((row) => {
    [
      row?.subscriptionId,
      row?.programSubscriptionId,
      row?.programSubscriptionID,
      row?.js_programSubscription?.ID,
    ]
      .filter((id) => id != null)
      .forEach((id) => planIds.add(String(id)));
  });
  return [...planIds].some((id) => hasActivePlanInPaymentHistory(list, id));
};

/**
 * True when the user has current access to the 6‑month transformation subscription SKU
 * (matches {@link JAPA_SIX_MONTH_TRANSFORMATION_MEMBERSHIP_PROGRAM_ID} on user or payment history).
 * @param {object} user Redux user
 * @param {Array|undefined} paymentHistoryList optional; defaults to `user.paymentHistoryList`
 */
export const hasActiveSixMonthTransformationMembership = (user, paymentHistoryList) => {
  return hasActiveProgramMembership(
    user,
    JAPA_SIX_MONTH_TRANSFORMATION_MEMBERSHIP_PROGRAM_ID,
    paymentHistoryList
  );
};

/**
 * True when the user currently has access to a given program subscription ID
 * via payment history or user.subscriptions / user.subscription.
 */
export const hasActiveProgramMembership = (user, planId, paymentHistoryList) => {
  const list = Array.isArray(paymentHistoryList)
    ? paymentHistoryList
    : user?.paymentHistoryList;

  if (hasActivePlanInPaymentHistory(list, planId)) {
    return true;
  }

  const now = new Date();
  const source = Array.isArray(user?.subscriptions) && user.subscriptions.length > 0
    ? user.subscriptions
    : (user?.subscription ? [user.subscription] : []);

  // isCancelled = cancel_at_period_end; access continues until expirationDate.
  return source.some((sub) => {
    if (!sub?.isSubscription) return false;
    if (String(sub.programSubscriptionId) !== String(planId)) return false;
    const expirationDate = sub.expirationDate ? new Date(sub.expirationDate) : null;
    return !expirationDate || expirationDate > now;
  });
};

export const isSubscriptionActive = (user) => {
  if (hasActiveAccessFromPaymentHistory(user?.paymentHistoryList)) {
    return true;
  }

  const now = new Date();

  const source = Array.isArray(user?.subscriptions) && user.subscriptions.length > 0
    ? user.subscriptions
    : (user?.subscription ? [user.subscription] : []);

  // ✅ Check for active subscription(s) (new array or legacy object)
  const hasActiveSubscription = source.some((sub) => {
    if (!sub?.isSubscription ) return false;
    const expirationDate = sub.expirationDate ? new Date(sub.expirationDate) : null;
    return !expirationDate || expirationDate > now;
  });

  if (hasActiveSubscription) return true;

  // ✅ Check for active corporate program (lifetime — no expiration)
  const hasCorporateProgram = user?.programPurchased?.some(
    (el) => el.isCorporate === true || el.isCorporate === "true"
  );


  if (hasCorporateProgram) {
    return true;
  }

  return false;
};

/**
 * verifyOtp field `dayFirstLogin`: backend uses 0 / false when the first-login offer
 * is still pending (show modal). Uses 1 / true after onboarding is done (hide modal).
 */
export const isDayFirstLoginOfferPending = (value) =>
  value === false || value === 0 || value === "0";
